export default __webpack_public_path__ + "static/printing_process-445e871114926079e03c2698674c6bba.jpg";